import { IDataGridOptions, IColDef } from 'components/common/DataGridDevEx/DataGrid.properties';

import {
  createActions, asyncInitialState, asyncOnRequest,
  asyncOnSuccess, asyncOnError, asyncSelectors,
  IDataAction,
  IExtendedState
} from '../utils';

export interface IBOMSerialsData {
  selected: any;
  gridOptions: IDataGridOptions;
  deleteObj: any;
  Actions: any;
  lineColumns: IColDef[];
  lines: any[];
}

export interface IBOMSerialsState extends IExtendedState<IBOMSerialsData> {
}

export const { types, actions } = createActions(
  {
    setSelected: (row) => ({ row }),
    clearLines: () => null,
    asyncs: {
      fetch: (Data) => (Data),
    }
  },
  'bomSerials');

const initialState = asyncInitialState<IBOMSerialsData>({
  selected: null,
  gridOptions: {
    doubleClickActionTab: '',
    suppressEditDeleteInContextMenu: true,
    rowModelType: 'serverSide',
    cacheBlockSize: 10,
    maxBlocksInCache: 5,
  },
  deleteObj: null,
  Actions: {
  },
  lineColumns: [
    { headerName: 'Serial number', field: 'SerialNumber', minWidth: 150, suppressSorting: true }
  ],
  lines: []
});

export default (state: IBOMSerialsState = initialState, action: IDataAction): IBOMSerialsState => {
  switch (action.type) {
    case types.setSelected:
      const selected = action.data.row;

      return {
        ...state,
        data: {
          ...state.data,
          selected: selected
        }
      };
    case types.fetch:
      return asyncOnRequest(state, action);
    case types.saga.fetch.success:
      return asyncOnSuccess(state, action, (data, successAction) => {
        const linesData = successAction.payload && successAction.payload.records;

        return {
          ...data,
          lines: linesData
        };
      });

    case types.saga.fetch.failure:
      return asyncOnError(state, action);
    default:
      return state;
  }
};

const asyncSelector = asyncSelectors(
  (state: { pickSlipEnquiry: { bomSerials: IBOMSerialsState } }) => state.pickSlipEnquiry.bomSerials,
  {
    lines: (data) => data.lines,
    selected: (data) => data.selected,
  }
);

const syncSelector = {
  isLoading: (state: { pickSlipEnquiry: { bomSerials: IBOMSerialsState } }) => state.pickSlipEnquiry.bomSerials.loading,
  gridOptions: (state: { pickSlipEnquiry: { bomSerials: IBOMSerialsState } }) => state.pickSlipEnquiry.bomSerials.data.gridOptions,
  lineColumns: (state: { pickSlipEnquiry: { bomSerials: IBOMSerialsState } }) => state.pickSlipEnquiry.bomSerials.data.lineColumns
};

export const selectors = { ...asyncSelector, ...syncSelector };
